module.exports = __webpack_public_path__ + "img/texture_grazed.7854d002.png";